// src/utils/uuid.ts

/**
 * Generates a v4 UUID.
 * Uses the built-in crypto.randomUUID() if available.
 * For older environments where crypto.randomUUID is not available, a basic fallback is used.
 *
 * @returns A v4 UUID string.
 */
export function generateUUIDv4(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Basic fallback for environments where crypto.randomUUID is not available.
  // This is a simplified version and not as robust as a full UUID library.
  // For production, consider a more comprehensive polyfill or library if wide compatibility is needed.
  console.warn(
    'UniqodeInsights SDK: crypto.randomUUID not available. Using a basic fallback for UUID generation. Consider a polyfill for older environments.'
  );
  let d = new Date().getTime(); //Timestamp
  let d2 = (typeof performance !== 'undefined' && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    let r = Math.random() * 16; //random number between 0 and 16
    if (d > 0) {
      //Use timestamp until depleted
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      //Use microseconds since page-load if supported
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}
